import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import TablePagination from "@material-ui/core/TablePagination";
import { palette } from "configurations/styles/theme";
import TableHeadVoucherAuthorized from "./header";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ClearIcon from '@material-ui/icons/Clear';
import {
  useTableAuthorizedIssuedVoucher,
  parseDate,
  parseDatetime,
} from "../Context/hook";
//componentes del sistema
import TablePaginationActions from "widgets/Tables/Pagination";
import MailForwarding from "../Buttons/MailForwarding";
import XMLVoucherBtn from "../../Buttons/XMLVoucherBtn";
import ViewerVoucherBtn from "../Buttons/ViewerVoucherBtn";
import { Button } from "@material-ui/core";
import { selectedResourceAction } from "redux/actions/resourcesActions";
import { useDispatch } from "react-redux";
import { setVoucherToDuplicate } from "redux/actions/authorizedVouchersAction";
import { Clear } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },

  tableBodyRow: {
    borderStyle: "solid",
    borderWidth: "0px 0px 1px 0px",
    borderColor: palette.primary.main,
    padding: "0px",
  },
  paginacion: {
    color: "black",
    fontSize: "12px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
  },
}));

const TableVoucherAuthorized = ({ rucEnterprise, setTotalElements }) => {

 
  const rucAvailablesToCufePo = ["155754584-2-2024"];
  const showPOColumn = rucAvailablesToCufePo.includes(rucEnterprise);
  const classes = useStyles();
  const dispatch = useDispatch();
  const selectedResource = (resource) =>
    dispatch(selectedResourceAction(resource));
  const handleClickFOP = (cafe) => {
    selectedResource({
      id: "FOP",
      nameMenu: "Factura Operación Interna",
      titlePage: "Factura Operación Interna",
      titleTab: "Factura Operación Interna",
      menuPadre: "GEN",
    });
    dispatch(setVoucherToDuplicate(cafe));
  };
  const {
    rows,
    currentPage,
    handleChangePage,
    rowsPerPage,
    handleChangeRowsPerPage,
    totalElements,
    handleSelectAllClick,
    handleClick,
    selected,
    isSelected,
  } = useTableAuthorizedIssuedVoucher();
  React.useEffect(() => {
    if (setTotalElements) setTotalElements(totalElements || 0);
  }, [totalElements, setTotalElements]);


  return (
    <Paper>
      <TableContainer>
        <Table
          className={classes.table}
          size="small"
          aria-label="a dense table"
        >
          <TableHeadVoucherAuthorized
            numSelected={selected.length}
            onSelectAllClick={handleSelectAllClick}
            rowCount={rows.length}
            rucEnterprise={rucEnterprise}
          />
          <TableBody>
            {rows.map((row, index) => {
              const isItemSelected = isSelected(
                row.comprobanteElectronico.idComprobanteElectronico,
              );
              const labelId = `enhanced-table-checkbox-${index}`;

              return (
                <TableRow
                  hover
                  onClick={(event) =>
                    handleClick(
                      event,
                      row.comprobanteElectronico.idComprobanteElectronico,
                    )
                  }
                  role="checkbox"
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  key={row.comprobanteElectronico.idComprobanteElectronico}
                  selected={isItemSelected}
                >
                  <TableCell
                    padding="checkbox"
                    classes={{ root: classes.tableBodyRow }}
                  >
                    <Checkbox
                      checked={isItemSelected}
                      inputProps={{ "aria-labelledby": labelId }}
                    />
                  </TableCell>
                  <TableCell
                    component="th"
                    classes={{ root: classes.tableBodyRow }}
                  >
                    {row.comprobanteElectronico.codigoSucursal}-{" "}
                    {row.comprobanteElectronico.puntoFacturacion} -{" "}
                    {row.comprobanteElectronico.numeroFactura}
                  </TableCell>
                  <TableCell
                    align="center"
                    classes={{ root: classes.tableBodyRow }}
                  >
                    {" "}
                    {parseDate(row.comprobanteElectronico.fechaEmision)}
                  </TableCell>
                  <TableCell
                    align="center"
                    classes={{ root: classes.tableBodyRow }}
                  >
                    {parseDatetime(
                      row.comprobanteElectronico.fechaAutorizacion,
                    )}
                  </TableCell>
                  <TableCell
                    align="justify"
                    classes={{ root: classes.tableBodyRow }}
                  >
                    {row.nombreReceptor}
                  </TableCell>
                   {showPOColumn && (
                    <TableCell align="center" classes={{ root: classes.tableBodyRow }}>
                      {row.comprobanteElectronico.uid ?? "-"}
                    </TableCell>
                  )}
                  <TableCell
                    align="center"
                    classes={{ root: classes.tableBodyRow }}
                  >
                    {row.comprobanteElectronico.tipoComprobanteElectronico.nombreComprobante.replaceAll(
                      "_",
                      " ",
                    )}
                  </TableCell>
                  <TableCell
                    align="center"
                    classes={{ root: classes.tableBodyRow }}
                  >
                    {"$ ".concat(row.comprobanteElectronico.valorTotal)}
                  </TableCell>
                  <TableCell
                    align="center"
                    classes={{ root: classes.tableBodyRow }}
                  >
                    {" "}
                    <ViewerVoucherBtn
                      iDoc={
                        row.comprobanteElectronico.tipoComprobanteElectronico
                          .codigoComprobante
                      }
                      txt={"Visualizar CAFE"}
                      voucher={row}
                    />{" "}
                  </TableCell>
                  <TableCell
                    align="center"
                    classes={{ root: classes.tableBodyRow }}
                  >
                    {" "}
                    <XMLVoucherBtn voucher={row} />{" "}
                  </TableCell>
                  <TableCell
                    align="center"
                    classes={{ root: classes.tableBodyRow }}
                  >
                    {" "}
                    <MailForwarding
                      iDoc={
                        row.comprobanteElectronico.tipoComprobanteElectronico
                          .codigoComprobante
                      }
                      voucher={row}
                    />{" "}
                  </TableCell>
                  <TableCell
                    align="center"
                    classes={{ root: classes.tableBodyRow }}
                  >
                    {row.comprobanteElectronico.tipoComprobanteElectronico
                      .idTipoComprobanteElectronico === 1 ? (
                      <Button
                        variant=""
                        color="primary"
                        size="small"
                        onClick={() => {
                          handleClickFOP(row.comprobanteElectronico.cufe ?? null);
                        }}
                      >
                        <FileCopyIcon fontSize="small" style={{ color: palette.primary.main }} />{" "}
                      </Button>
                    ) : (
                      <ClearIcon fontSize="small" style={{ color: palette.primary.main }} />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 30, 50, 100, 500]}
        component="div"
        count={totalElements}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página: "
        className={classes.paginacion}
        ActionsComponent={TablePaginationActions}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count}`
        }
      />
    </Paper>
  );
};

export default React.memo(TableVoucherAuthorized);
